import { SetPostSupportUpdateStatus } from './thunk/setPostSupportUpdateStatus';
import {SetGetSupportList} from './thunk/setGetSupportList';
import {SetGetSupportView} from './thunk/setGetSupportView';

export const Thunks = {
    SetGetSupportList,
    SetGetSupportView,
    SetPostSupportUpdateStatus
}